import { trpc } from "@/trpc/client";
import { campaignHeader } from "@/trpc/calls";

function teamLookupInput(filter) {
  const raw = String(filter || "");
  const id = raw.match(/team_id['"]?\s*:\s*(\d+)/);
  if (id) return { team_id: Number(id[1]) };
  const url = raw.match(/team_analytics_url['"]?\s*:\s*['"]([^'"]+)['"]/);
  if (url) return { analytics_url: url[1] };
  return null;
}

const teamData = async (variables) => {
  const input = teamLookupInput(variables?.filter);
  if (!input) return null;
  return trpc.lookups.team.resolve.query(input);
};

const getDataCampaign = async (variables) => {
  return campaignHeader(variables);
};

const getDataToken = async (variables) => {
  const result = await trpc.auth.createSiteAnalyticsAccess.mutate({
    campaign_id: Number(variables.campaignId),
    site_id: Number(variables.siteId),
    origin: window.location.origin,
  });
  const url = new URL(
    `/dashboard/campaign/${result.campaign_id}/site/${result.site_id}`,
    window.location.origin
  );
  url.searchParams.set("access", result.jwt);
  return {
    code: "200",
    message: "Token gerado",
    data: url.toString(),
  };
};

/** Analytics white-label abre o beta no app do mesmo domínio, não no app 00px. */
const BETA_APP_BY_ANALYTICS_HOST = {
  "analytics.adserverstart.com": "https://app.adserverstart.com",
  "analytics.greenadserver.com.br": "https://app.greenadserver.com.br",
  "analytics.adx.space": "https://app.adx.space",
  "analytics.vetta.net.br": "https://app.vetta.net.br",
  "analytics.brasiladserver.com.br": "https://app.brasiladserver.com.br",
};

function analyticsV5Base() {
  if (typeof window !== "undefined" && window.location && window.location.hostname) {
    const mapped = BETA_APP_BY_ANALYTICS_HOST[window.location.hostname.toLowerCase()];
    if (mapped) return mapped;
  }
  const raw = process.env.VUE_APP_ANALYTICS_V5_URL;
  if (raw == null || String(raw).trim() === "") return "";
  return String(raw).replace(/\/+$/, "");
}

function betaReturnTo(campaignId, siteId) {
  const path = siteId
    ? `/analytics/campaigns/${campaignId}/sites/${siteId}`
    : `/analytics/campaigns/${campaignId}`;
  const params = new URLSearchParams({ beta: "1", origin: window.location.origin });
  return `${path}?${params.toString()}`;
}

/**
 * Abre a mesma campanha na versão beta no app do domínio atual
 * (app.adserverstart.com, app.greenadserver.com.br, app.adx.space, app.vetta.net.br, app.brasiladserver.com.br)
 * ou em VUE_APP_ANALYTICS_V5_URL nos demais hosts.
 * Guest do token de veículo reusa o JWT.
 * Usuário logado troca a sessão por um código de uso único; o v5 grava o cookie dele em /auth/callback.
 */
async function openAnalyticsV5Beta({ campaignId, siteId, guestJwt }) {
  const base = analyticsV5Base();
  if (!base) return;
  if (guestJwt) {
    const url = new URL(
      `/analytics/access/${encodeURIComponent(guestJwt)}`,
      base
    );
    url.searchParams.set("beta", "1");
    url.searchParams.set("origin", window.location.origin);
    window.location.assign(url.toString());
    return;
  }
  if (!Number.isInteger(campaignId) || campaignId <= 0) {
    throw new Error("Campanha inválida");
  }
  const created = await trpc.auth.handoffCreate.mutate({
    app_id: "admin-v5",
    return_to: betaReturnTo(campaignId, siteId),
    beta: { campaign_id: campaignId, site_id: siteId || null },
  });
  if (!created || !created.code) {
    throw new Error("Não foi possível preparar o acesso");
  }
  const url = new URL("/auth/callback", base);
  url.searchParams.set("code", created.code);
  window.location.assign(url.toString());
}

export { teamData, getDataCampaign, getDataToken, analyticsV5Base, openAnalyticsV5Beta };
